import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { host_url } from '../../App'; // Import host_url
import { MdKeyboardArrowDown } from "react-icons/md"; // Importiere das Chevron-Icon
import "./Dienstplaene.css";
import "../../styles/CiTable.css";
import BackArrow from '../../BackArrow'; // Importiere die BackArrow-Komponente
import LogistikDienstplaene from './logistik/LogistikDienstplaene';

function leseBereichCookie() {
  return document.cookie
    .split('; ')
    .find(row => row.startsWith('Bereich='))
    ?.split('=')[1] || '';
}

function Dienstplaene() {
  const [dienstplaene, setDienstplaene] = useState([]);
  const [bereich, setBereich] = useState(leseBereichCookie);
  const today = new Date().toISOString().split('T')[0]; // Ensure today only includes the date part
  const [selectedDate, setSelectedDate] = useState(today); // Set initial state to today's date part
  const navigate = useNavigate();

  useEffect(() => {
    setSelectedDate(today); // Ensure selectedDate is set to today's date part on component mount
  }, [today]);

  useEffect(() => {
    const cookieValue = leseBereichCookie();
    setBereich(cookieValue);
    if (cookieValue === 'Logistik') return;

    fetch(`${host_url}/dienstplaene`)
      .then((response) => response.json())
      .then((data) => {
        const formattedData = data.map(plan => ({
          ...plan,
          Datum: new Date(plan.Datum).toISOString().split('T')[0] // Format Datum to match YYYY-MM-DD
        }));
        setDienstplaene(formattedData);
      })
      .catch((error) => console.error("Fehler:", error));
  }, []);

  const formatDate = (dateString) => {
    const options = { day: 'numeric', month: 'long'};
    const date = new Date(dateString);
    return date.toLocaleDateString('de-DE', options);
  };

  const formatTime = (timeString) => {
    const [hours, minutes] = timeString.split(':');
    return `${hours}:${minutes}`;
  };

  const uniqueDates = Array.from(new Set(dienstplaene
    .filter(plan => plan.Bereich === bereich)
    .map(plan => plan.Datum)))
    .sort((a, b) => new Date(a) - new Date(b)); // Sort dates chronologically

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const groupedDienstplaene = Array.isArray(dienstplaene) ? dienstplaene.reduce((acc, plan) => {
    if (!acc[plan.Dienst]) {
      acc[plan.Dienst] = [];
    }
    acc[plan.Dienst].push(plan);
    return acc;
  }, {}) : {};

  const handleSpuelplanClick = () => {
    navigate('/spuelplan');
  };

  // Gibt es für Bereich + gewählten Tag überhaupt Dienste? (für den Leer-Hinweis)
  const hasAnyPlans = dienstplaene.some(
    plan => plan.Bereich === bereich && (selectedDate === '' || plan.Datum === selectedDate)
  );

  const sortByTime = (plans) => {
    return plans.sort((a, b) => {
      const timeA = a.Uhrzeit.split(':').map(Number);
      const timeB = b.Uhrzeit.split(':').map(Number);
      return timeA[0] - timeB[0] || timeA[1] - timeB[1];
    });
  };

  if (bereich === 'Logistik') {
    return <LogistikDienstplaene mode="hub" />;
  }

  return (
    <div>
            <div className="page-header">
        <BackArrow to="/" />
        <h1>Dienste am {selectedDate ? new Date(selectedDate).toLocaleDateString('de-DE', { weekday: 'long' }) : 'aktuellen Tag'}</h1>
      </div>
      <div className="dropdown-form">
        <label htmlFor="date-filter">Tagesfilter</label>
        <div className={`dropdown-wrapper ${uniqueDates.includes(selectedDate) ? 'filled' : ''}`}>
          <select id="date-filter" value={selectedDate} onChange={handleDateChange}>
            <option value="">Wähle einen Tag</option>
            {uniqueDates.map(date => (
              <option key={date} value={date}>
                {new Date(date).toLocaleDateString('de-DE', {
                  weekday: 'short', year: 'numeric', month: 'long', day: 'numeric'
                })}
              </option>
            ))}
          </select>
          <MdKeyboardArrowDown className="dropdown-chevron" />
        </div>
      </div>
      {bereich === 'Logistik' && (
        <button className="jobbutton spuelplan-button" onClick={handleSpuelplanClick}>Spülplan Gesamtübersicht</button>
      )}
      {!hasAnyPlans && (
        <p>Für diesen Tag sind keine Dienste eingetragen.</p>
      )}
      {Object.keys(groupedDienstplaene).map((dienst) => {
        const filteredPlans = sortByTime(groupedDienstplaene[dienst].filter(plan => plan.Bereich === bereich && (selectedDate === '' || plan.Datum === selectedDate)));
        if (filteredPlans.length === 0) return null;
        return (
          <div key={dienst}>
            <h2>{dienst}</h2>
            <div className="ci-table-wrapper">
            <table className="ci-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Datum</th>
                  <th>Uhrzeit</th>
                </tr>
              </thead>
              <tbody>
                {filteredPlans.map((plan) => (
                  <tr key={plan.Teamer}>
                    <td>{plan.Teamer}</td>
                    <td>{formatDate(plan.Datum)}</td>
                    <td>{formatTime(plan.Uhrzeit)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Dienstplaene;
